import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  container: {
    backgroundColor: '#FDD129',
    paddingTop: 88,
    paddingBottom: 88,
  },
  title: {
    fontFamily: 'proximanova-bold, sans-serif',
  },
  subsection: {
    margin: '3em 0',
  },
  quote: {
    position: 'relative',
  },
  quotationMark: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  quoteText: {
    display: 'block',
    margin: '0 0 0 36px',
  },
  quoteName: {
    fontFamily: 'proximanova-bold, proximanova-regular',
    fontSize: '1.2em',
    fontWeight: 700,
    textAlign: 'right',
  },
});

export default makeStyles(styles);
